module.exports = __webpack_public_path__ + "img/m-xiaoshouguanli.3e69fd1e.svg";